import React, { InputHTMLAttributes, forwardRef } from 'react';
import style from './input.module.scss';
import CloseIcon from '../../../../../assets/svg/solo-chat/circle-cross-2.svg';
import EnterIcon from '../../../../../assets/svg/solo-chat/curved-arrow.svg';

type Props = {
	close: () => void;
	error?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef((props: Props, ref: any) => {
	const { close, error, ...inputProps } = props;
	return (
		<div className={style.inputWrapper}>
			<div className={style.input}>
				<input ref={ref} {...inputProps} />
				<button onClick={close}>
					<img src={CloseIcon} />
				</button>
				<img className={style.enter} src={EnterIcon} alt="enter" />
			</div>
			{error && <span className={style.error}>{error}</span>}
		</div>
	);
});
